<div class="event-data" [class.event-data--secondary]="variant() === 'secondary'">
  <div #videoPlayerVisibility style="position: absolute; height: 1px; width: 100%"></div>

  @if (videoAccessState$ | async; as state) {
    @if (!state.loading) {
      @if (requiresPurchase) {
        <div class="disabled-layer"></div>
      }
      <div
        class="video-player"
        [class.mobile-video-player]="variant() === 'primary'"
        [class.video-player--secondary]="variant() === 'secondary'"
      >
        @if (!trailerVideoToken) {
          @if (postUrl()) {
            <a
              class="video-thumbnail offer-to-register-button offer-to-register-button--without-gradient"
              [style.background-image]="'url(' + item().content.videos?.[0]?.preview_url + ')'"
              [href]="postUrl()"
              [target]="target()"
              (click)="onPostClick($event)"
              dataTest="post-video-thumbnail-link"
            ></a>
          } @else {
            <div
              class="video-thumbnail offer-to-register-button offer-to-register-button--without-gradient"
              [style.background-image]="'url(' + item().content.videos?.[0]?.preview_url + ')'"
              dataTest="post-video-thumbnail"
            ></div>
          }
        }
        @if (trailerVideoToken) {
          <div class="trailer-video-container">
            <div class="trailer-video-container">
              <app-stream
                [activatePlay]="trailerPromoPlay"
                [streamUrl]="trailerToken"
                [watchedDuration]="0"
                [poster]="item().content.videos?.[0]?.preview_url"
                [muted]="mutedTrailer"
                [loop]="true"
                [controls]="false"
                class="trailer-video"
                (sendVideoProgress)="addWatchProgress($event)"
              />
            </div>
            <div class="trailer-play-layer" (click)="playVideo($event, trailerVideoToken)"></div>
            <div class="sound-actions">
              <span class="sound-control" [class.off]="mutedTrailer" (click)="mutedTrailer = !mutedTrailer">
                @if (mutedTrailer) {
                  <outlaw-icon class="icon-svg icon-muted" name="noSound" />
                } @else {
                  <outlaw-icon class="icon-svg icon-sound" name="sound" />
                }
              </span>
            </div>
          </div>
        }
      </div>
      <div class="date">{{ item().created_at | unixDateFormatter }}</div>
      @if (canDisplayPostContent) {
        <div class="post-content">
          @if (item().content.title) {
            @if (postUrl()) {
              <a
                [href]="postUrl()"
                class="post-title-link"
                [target]="target()"
                (click)="onPostClick($event)"
                dataTest="post-title-link"
              >
                <div class="title" dataTest="post-title">
                  {{ item().content.title }}
                </div>
              </a>
            } @else {
              <div class="title" dataTest="post-title">
                {{ item().content.title }}
              </div>
            }
          }

          <div class="text-block" [class.disable-state]="requiresPurchase">
            @if (requiresPurchase) {
              <button class="community-button subscribe" (click)="onSubscribeClick($event)" dataTest="btn-subscribe">
                <outlaw-icon class="icon-svg" name="ticket" />
                Subscribe to watch
              </button>
            }

            @if (item().content.text) {
              @if (postUrl()) {
                <a
                  [href]="postUrl()"
                  class="post-description-link"
                  [target]="target()"
                  (click)="onPostClick($event)"
                  dataTest="post-description-link"
                >
                  <div class="description" [class.short-text]="requiresPurchase" dataTest="post-description">
                    {{ item().content.text | formatLineBreaks }}
                  </div>
                </a>
              } @else {
                <div class="description" [class.short-text]="requiresPurchase" dataTest="post-description">
                  {{ item().content.text | formatLineBreaks }}
                </div>
              }
            }
          </div>
        </div>
      }
      @if (canDisplayWatchButton) {
        <div class="watch-button-container" [class.watch-button-container--secondary]="variant() === 'secondary'">
          <button
            #watchButton
            type="button"
            class="watch-film community-button primary"
            [style]="{ position: 'relative' }"
            (click)="watchClick($event, state.access?.stream_url)"
            dataTest="btn-watch-film"
          >
            <outlaw-icon class="icon-svg" name="playCircle" />
            Watch
          </button>
        </div>
      }
    } @else {
      <app-community-loader />
    }
  }
</div>
